function returnOptions(data) {
  // 计算总和
  const arr = [];
  data.map((item) => arr.push(item.memberAmount, item.noMemberAmount));
  let sum = 0;
  for (let i = 0; i < arr.length; i++) {
    sum += arr[i];
  }
  return {
    color: ['#20a0ff', ' #fe6d6c', '#fdd451'],
    graphic: [{
      type: 'text',
      left: '27.5%',
      top: '58%',
      style: {
        text: '会员',
        textAlign: 'center',
        fill: '#000',
        fontSize: 18,
        color: '#4d4f5c',
      }
    }, {
      type: 'text',
      left: '67.5%',
      top: '58%',
      style: {
        text: '散客',
        textAlign: 'center',
        fill: '#000',
        fontSize: 18,
      }
    },
    ],
    title: {
      show: true,
      text: '顾客消费额度统计',
      subtext: `消费总额（元）：${Number(sum).toFixed(2)}`,
    },
    legend: {
      orient: 'vertical',
      left: 'right',
    },
    // 自定义提示框浮层
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c} <br/>占比：{d}%'
    },
    series: [{
      type: 'pie',
      center: ['30%', '60%'],
      radius: ['30%', '70%'],
      avoidLabelOverlap: false,
      label: {
        // 饼图图形上的文本标签
        normal: {
          show: true,
          position: 'inner', // 标签的位置
          textStyle: {
            fontWeight: 300,
            fontSize: 12, // 文字的字体大小
            color: '#fff',
          },
          formatter: '{d}%',
        },
      },

      labelLine: {
        show: false
      },
      // 会员
      data: [
        { value: data[0].memberAmount, name: '项目消费额度' },
        { value: data[1].memberAmount, name: '产品消费额度' },
        { value: data[2].memberAmount, name: '套餐消费额度' },
      ]
    },
    {
      type: 'pie',
      center: ['70%', '60%'],
      radius: ['30%', '70%'],
      avoidLabelOverlap: false,
      label: {
        // 饼图图形上的文本标签
        normal: {
          show: true,
          position: 'inner', // 标签的位置
          textStyle: {
            fontWeight: 300,
            fontSize: 12, // 文字的字体大小
            color: '#fff',
          },
          formatter: '{d}%',
        },
      },
      labelLine: {
        show: false
      },
      data: [
        { value: data[0].noMemberAmount, name: '项目消费额度' },
        { value: data[1].noMemberAmount, name: '产品消费额度' },
        { value: data[2].noMemberAmount, name: '套餐消费额度' },
      ]
    },
    ]
  };
}
export const echartsC = returnOptions;
